<template>
  <div class="container">
    <h1>API</h1>

    <h2>CitSci API</h2>
    <p>
      CitSci is built on
      <IconLink href="https://api.citsci.org/">Application Programming Interfaces</IconLink>
      (API).
      We built CitSci 2.0 from the ground up to be 100% API-based. Read more about how you can use our
      <IconLink href="https://api.citsci.org/">API</IconLink>
      as a developer. Whether integrating your own front-end web app or your own third
      party mobile app, our API enables you to use the full power of our citizen
      science platform and backend cyber-infrastructure.
    </p>

    <h2>We Give You Flexibility</h2>
    <p>
      Using our API you'll gain the ability to create projects, register users,
      create datasheets, submit observations, view projects, view observations,
      and view locations. This will enable you to develop your own custom apps
      that can view and make use of CitSci data in custom ways. We're excited to
      see what you create.
    </p>

    <h2>Documentation</h2>
    <p>
      Our API is self documenting and gives you a testbed to try them out. We
      use
      <IconLink href="https://api-platform.com/">API-Platform</IconLink>
      and hope to provide
      even more detailed documentation with use case examples in the future.
    </p>

    <h2>Learn More</h2>
    <p>
      Please
      <b-link to="contact">contact us</b-link>
      to learn more. We can set you up with any needed authorization keys.
    </p>
  </div>
</template>

<script>
import IconLink from '../../components/layout/IconLink.vue';

export default {
  components: {
    IconLink
  }
}
</script>
